import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import { spineLoader } from '@play-co/timestep-spine';
import { HeaderFrozen } from '../components/HeaderFrozen';

const folder = 'assets/minigame/rescueLevel/theme-frozen';

const assetMap = {
  iconSmall: `${folder}/icon_small.png`,
  iconLarge: `${folder}/icon_large.png`,
  dream: `${folder}/dream.png`,
  snowflake1: `${folder}/snowflake_1.png`,
  snowflake2: `${folder}/snowflake_2.png`,
  snowflake3: `${folder}/snowflake_3.png`,
  snowflake4: `${folder}/snowflake_4.png`,
  header: {
    loadMethod: spineLoader,
    url: `${folder}/animation/rescue_frozen`,
  },
};

export const rescueLevelThemeFrozen = {
  getHeader: (opts: ViewOpts) => new HeaderFrozen(opts),
  getAssets: () => Object.values(assetMap),
  getDream: (opts: ViewOpts) => {
    return new ImageScaleView({
      image: assetMap.dream,
      width: 135,
      height: 122,
      centerOnOrigin: true,
      ...opts,
    });
  },
  getIconLarge: (opts: ViewOpts) => {
    return new ImageScaleView({
      image: assetMap.iconLarge,
      width: 364,
      height: 352,
      centerOnOrigin: true,
      ...opts,
    });
  },
  getIconSmall: (opts: ViewOpts) => {
    return new ImageScaleView({
      image: assetMap.iconSmall,
      width: 129,
      height: 125,
      centerOnOrigin: true,
      ...opts,
    });
  },
  getSnowflakes: () => [
    assetMap.snowflake1,
    assetMap.snowflake2,
    assetMap.snowflake3,
    assetMap.snowflake4,
  ],
  getHeaderSpine: () => assetMap.header.url,
};
